var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { FeatureFlagsContext } from '../FeatureFlagContext';
export const useFeatureFlagsContext = () => {
    _react_refresh_temp_1();
    const featureFlagsValue = useContext(FeatureFlagsContext);
    if (!featureFlagsValue) {
        // Temporary commented out in order to resolve the release3 to master
        // throw new Error('FeatureFlagContext missing.');
        return { isPending: false, isError: true, variants: undefined };
    }
    return featureFlagsValue;
};
_react_refresh_temp_1(useFeatureFlagsContext, "enwE5a98vyIOCQs+hZiVkBhmQjI=");
